<div class="password-wrapper" [ngStyle]="{marginBottom: mb}">
  <app-base-input [id]="id" [name]="name" [type]="showPassword ? 'text' : 'password'" [placeholder]="placeholder"
    [value]="value" (valueChange)="onInput($event)" (focusEvent)="handleFocus($event)" (blurEvent)="handleBlur($event)"
    (onEnter)="onEnter.emit()" [autocomplete]="autocomplete" [ariaLabel]="ariaLabel" [maxlength]="maxlength"
    [isFluid]="isFluid" [disabled]="disabled" [mt]="mt"></app-base-input>
  <button type="button" class="toggle-btn" (click)="togglePassword()"
    [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [disabled]="disabled">
    <app-svg-loader *ngIf="!showPassword" height="22px" url="assets/svg/hide-outline.svg"></app-svg-loader>
    <app-svg-loader *ngIf="showPassword" height="22px" url="assets/svg/show-outline.svg"></app-svg-loader>
  </button>
  <div class="strength" *ngIf="strengthLabel">
    <div class="bars">
      <span class="bar" [ngClass]="{weak: strength >= 1, inactive: strength < 1}"></span>
      <span class="bar" [ngClass]="{strong: strength >= 2, inactive: strength < 2}"></span>
      <span class="bar" [ngClass]="{very: strength >= 3, inactive: strength < 3}"></span>
    </div>
    <span class="label">{{ strengthLabel }}</span>
  </div>
</div>